import { Hourglass } from 'lucide-react';
import { EmptyState } from '../../../shared/components/EmptyState';

/** A section the trip page has a place for but nothing behind yet; it says so rather than looking empty or broken. */
export function SectionNotAvailable({ name }: { name: string }) {
  return <EmptyState icon={Hourglass} title={`${name} are not available yet`} description={`${name} for a trip will appear here once they are built.`} />;
}
